import { jsx as f } from "react/jsx-runtime";
import { c as x } from "react/compiler-runtime";
import { Button as u } from "@mui/material";
function B(t) {
  const e = x(24);
  let a, o, s, n, r, g, l;
  e[0] !== t ? ({
    btype: g,
    width: l,
    height: o,
    size: n,
    sx: r,
    children: a,
    ...s
  } = t, e[0] = t, e[1] = a, e[2] = o, e[3] = s, e[4] = n, e[5] = r, e[6] = g, e[7] = l) : (a = e[1], o = e[2], s = e[3], n = e[4], r = e[5], g = e[6], l = e[7]);
  const c = v[g === void 0 ? "primary" : g];
  let i;
  e[8] !== l ? (i = l && {
    width: l
  }, e[8] = l, e[9] = i) : i = e[9];
  let y;
  e[10] !== o ? (y = o && {
    height: o
  }, e[10] = o, e[11] = y) : y = e[11];
  let p;
  e[12] !== r ? (p = Array.isArray(r) ? r : [r], e[12] = r, e[13] = p) : p = e[13];
  let d;
  e[14] !== c || e[15] !== i || e[16] !== y || e[17] !== p ? (d = [c, i, y, ...p], e[14] = c, e[15] = i, e[16] = y, e[17] = p, e[18] = d) : d = e[18];
  let b;
  return e[19] !== a || e[20] !== s || e[21] !== n || e[22] !== d ? (b = /* @__PURE__ */ f(u, { size: n, sx: d, ...s, children: a }), e[19] = a, e[20] = s, e[21] = n, e[22] = d, e[23] = b) : b = e[23], b;
}
const v = {
  primary: (t) => ({
    borderColor: `${t.vars?.palette.grey[200] ?? t.palette.grey[200]}`,
    borderRadius: 1,
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none"
    }
  }),
  secondary: (t) => ({
    border: `1px solid ${t.vars?.palette.grey[200] ?? t.palette.grey[200]}`,
    backgroundColor: t.vars?.palette.grey[50] ?? t.palette.grey[50],
    color: t.vars?.palette.grey[600] ?? t.palette.grey[600],
    boxShadow: "none",
    "&:hover": {
      backgroundColor: t.vars?.palette.grey[200] ?? t.palette.grey[200],
      boxShadow: "none"
    }
  })
};
export {
  B as Button
};
